import { render, staticRenderFns } from "./ShadowCochl.vue?vue&type=template&id=ac6b75ca&scoped=true"
import script from "./ShadowCochl.vue?vue&type=script&lang=js"
export * from "./ShadowCochl.vue?vue&type=script&lang=js"
import style0 from "./ShadowCochl.vue?vue&type=style&index=0&id=ac6b75ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6b75ca",
  null
  
)

export default component.exports